import React, { useEffect, useState } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';

// Import pages
import HomePage from './pages/HomePage';
import CruciblePage from './pages/CruciblePage';
import AboutPage from './pages/AboutPage';
import DailyGlowPage from './pages/DailyGlowPage';
import ExpeditionsPage from './pages/ExpeditionsPage';
import SparkMomentsPage from './pages/SparkMomentsPage';
import HeartlinesPage from './pages/HeartlinesPage';
import WaitlistPage from './pages/WaitlistPage';
import ContactPage from './pages/ContactPage';

// Component to handle scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const [mounted, setMounted] = useState(false);
  const { scrollY } = useScroll();
  const opacity = useTransform(scrollY, [0, 300], [1, 0.8]);

  useEffect(() => {
    setMounted(true);
    
    // Intersection Observer for scroll animations
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
        }
      });
    }, observerOptions);

    // Observe all elements with animate-on-scroll class
    setTimeout(() => {
      const animatedElements = document.querySelectorAll('.animate-on-scroll');
      animatedElements.forEach(el => observer.observe(el));
    }, 100);

    return () => observer.disconnect();
  }, []);

  if (!mounted) {
    return (
      <div className="min-h-screen bg-neutral-warm flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 bg-ember-gradient rounded-xl mx-auto mb-4 pulse-glow"></div>
          <p className="text-neutral-medium">Igniting the experience...</p>
        </div>
      </div>
    );
  }

  return (
    <HelmetProvider>
      <div className="App font-body bg-neutral-warm text-neutral-charcoal overflow-x-hidden">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/crucible" element={<CruciblePage />} />
            <Route path="/dailyglow" element={<DailyGlowPage />} />
            <Route path="/expeditions" element={<ExpeditionsPage />} />
            <Route path="/spark-moments" element={<SparkMomentsPage />} />
            <Route path="/heartlines" element={<HeartlinesPage />} />
            <Route path="/waitlist" element={<WaitlistPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;